import { Component } from '@angular/core';
import {Router} from '@angular/router';
import {ProjectService} from 'src/app/Services/project.service';
import { SharedService } from 'src/app/Services/sharedService';
import moment from "moment";
import { TokenEncryptionService } from 'src/app/Services/token-encryption.service';

@Component({
    selector: 'app-plan-expired',
    templateUrl: './plan-expired.component.html',
    styleUrl: './plan-expired.component.css',
    standalone: false
})
export class PlanExpiredComponent {

isAdmin:any = true;
dateOfExpiration: string = '';
quotaStatus: string = '';
constructor(private router: Router,private _sharedServices:SharedService, private tokenEncryptionService: TokenEncryptionService){
  this._sharedServices.sideMenuSubject.next(true);
  const item = this.tokenEncryptionService.getEncryptedItem<any>('user');
  if(item){
  this.quotaStatus = item.meta.quota_status;
  let isExpired = this._sharedServices.checkPlanExpired(item)
  if (isExpired == false) {
     this.router.navigateByUrl('dashboard'); 
  }
  // Set expiration date
  if (item.meta && item.meta.expires_at) {
    this.dateOfExpiration = moment(item.meta.expires_at).format('DD MMM YYYY');
  }
}
  if(localStorage.getItem('isAdmin')){
    this.isAdmin = JSON.parse(localStorage.getItem('isAdmin'));
  }else{
    this.isAdmin = false;
  }
}

sendPaymentRequest(){
  this.router.navigate(["/billings"]);
}

// Helper methods to reduce duplication
isExpired(): boolean {
  const status = this.quotaStatus?.toLowerCase();
  return status === 'expired';
}

isTrialExpired(): boolean {
  const status = this.quotaStatus?.toLowerCase();
  return status === 'trial-expired';
}

isActive(): boolean {
  const status = this.quotaStatus?.toLowerCase();
  return status === 'active';
}

getActionText(): string {
  if (this.isTrialExpired()) return 'Buy';
  if (this.isActive()) return 'Renew';
  if (this.isExpired()) return 'Upgrade or renew .';
  return '';
}


getButtonText(): string {
  if (this.isTrialExpired()) return 'Buy';
  if (this.isActive()) return 'Renew';
  if (this.isExpired()) return 'Upgrade';
  return '';
}

getTitleText(): string {
  if (this.isExpired()) return 'Your plan has Expired';
  if (this.isTrialExpired()) return 'Your trial has expired';
  return '';
}
}
